import React from 'react';

import {
  BrandSafetyThirdPartyUnknown,
  BrandSafetyTrackerActiveActive,
  BrandSafetyTrackerAlwaysOnActive,
  BrandSafetyTrackerChannelTargetingAll,
  IBrandSafetyTracker,
  IBrandSafetyTrackerEvent,
} from '~/src/dash/api/brand-safety-tracker';
import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import {
  formatDateWithOffsetToUTC,
  getFutureEndDate,
  getFutureStartDate,
} from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import { BrandSafetyTrackerEdit } from '~/src/dash/views/brand-safety-tracker-edit';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IHistoryProps,
    IUserStateProps {}

export const BrandSafetyTrackerNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
  },
  function ({ session }: IProps) {
    // create a new empty rule with default values
    const newTracker: IBrandSafetyTracker = {
      ID: 0,
      PublisherID: Number(session.publisher.ID),
      Name: 'New Brand Safety Tracker',
      Active: BrandSafetyTrackerActiveActive,
      ThirdParty: BrandSafetyThirdPartyUnknown,
      AlwaysOn: BrandSafetyTrackerAlwaysOnActive,
      StartDate: formatDateWithOffsetToUTC(
        getFutureStartDate(session.publisher.Timezone || 'UTC'),
        session.publisher.Timezone || 'UTC',
      ),
      EndDate: formatDateWithOffsetToUTC(
        getFutureEndDate(session.publisher.Timezone || 'UTC', 6, 'day'),
        session.publisher.Timezone || 'UTC',
      ),
      Timezone: session.publisher.Timezone || 'UTC',
      MeasuredInventory: 100,
      BrandSafetyTrackerEvents: [] as IBrandSafetyTrackerEvent[],
      ChannelTargeting: BrandSafetyTrackerChannelTargetingAll,
      SiteIDS: [],
      ChannelGroupIDS: [],
      BidderGroupIDS: [],
      BidderIDS: [],
    };
    // display the edit form for this new tracker
    return (
      <div>
        <BrandSafetyTrackerEdit tracker={newTracker} error={''} />
      </div>
    );
  },
);
